import { render, staticRenderFns } from "./AlivesDetail.vue?vue&type=template&id=4691b088"
import script from "./AlivesDetail.vue?vue&type=script&lang=js"
export * from "./AlivesDetail.vue?vue&type=script&lang=js"
import style0 from "./AlivesDetail.vue?vue&type=style&index=0&id=4691b088&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports